export default "__VITE_ASSET__BeX$zT5a__"